import { mockBuilder } from '../utils/builderHelper.es.js';
import { Price } from './Price.es.js';

/** @module Mocks */ /** typedoc */
function aPrice() {
    return mockBuilder(new Price()).withValue(9.99).withCurrencyCode('USD').withCurrencySymbol('$');
}

export { aPrice };
